export default "__VITE_ASSET__fRXP4GEs__"